import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getAuth } from 'firebase/auth';

const GetUserData = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const obtenerPerfilUsuarioActual = async () => {
      if (!auth.currentUser) {
        console.log('No hay usuario autenticado');
        setUserData(null);
        setLoading(false);
        return;
      }

      const uid = auth.currentUser.uid;
      const userDocRef = doc(db, 'usuarios', uid);

      try {
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          setUserData(userDocSnap.data());
        } else {
          console.log('No existe perfil en Firestore para este usuario');
          setUserData(null);
        }
      } catch (error) {
        console.error('Error al obtener datos de usuario:', error);
        setUserData(null);
      } finally {
        setLoading(false);
      }
    };

    obtenerPerfilUsuarioActual();
  }, [auth.currentUser]);

  return { userData, loading };
};

export default GetUserData;
